import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../core/services/admin.service';
import { environment } from 'src/environments/environment';
import { IBannerImageBody } from '../../core/models/index';
import { ItemService } from '../../core/services/item.service';
import { UserService } from '../../core/services/user.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  bannerImgList: any;
  imageURL: string;
  apiImageUrl: string;
  languageCode: string;
  isLogin: boolean;


  constructor(private adminService: AdminService, private itemService: ItemService, private userService: UserService) {
    this.isLogin = this.userService.isAuthenticated();
    this.userService.isUserLoggedIn.subscribe(response => {
      this.isLogin = response;
    });
  }
  ngOnInit(): void {
    //this.languageCode = 'eng';// localStorage.getItem('language');
    this.languageCode = localStorage.getItem('language');
    this.imageURL = environment.imageUrl;
    this.getBannerImages();
  }

  getBannerImages() {
    const body: IBannerImageBody = {
      languageCode: this.languageCode
    }

    this.adminService.GetBannerImages(body).subscribe((response) => {
      this.bannerImgList = response;   
    });
  }

}
